<template>
  <NuxtLayout class="app-entry">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useNuxtApp } from '#imports';
import { useSSRContext } from 'vue';
import { useEnvironmentStore } from './src/store';
import { getRuntimeContext } from './server/helpers/server';
import { useUserStore } from './src/store/modules/user';
import { GLOBAL_CONFIG } from '~/configs/environment/environment';
import VConsole from 'vconsole';
const nuxtApp = useNuxtApp();

const envStore = useEnvironmentStore();
// 全局用户信息
const userStore = useUserStore();

if (process.server) {
  const ssrContext = useSSRContext();
  const runtimeContext = getRuntimeContext(ssrContext?.event);

  envStore.setIsMobile(runtimeContext.isMobile);
}

if (process.client) {
  userStore.updateUserInfo({
    nuxtApp,
  });

  if (GLOBAL_CONFIG.env !== 'production' && envStore.isMobile) {
    // new VConsole({ theme: 'dark' });
  }
}
</script>
